import React, { Component } from "react";
import fire from '../fire';
import { Grid, List, Label, Header } from "semantic-ui-react";
import { Link } from "react-router-dom";
import Loading from "../SiteLayout/Loading";

class AllSurahView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      lessons:[]
    };
  }

  componentDidMount() {  
    const response = fire.firestore().collection("tajweed");
    
    response.get().then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        var data = doc.data();

        let lesson = {
          number: data.number,
          name: data.name
        }

        this.setState({
          isLoading: false,
          lessons: [...this.state.lessons, lesson]
        })
      });          
    });
  }


  render(){
    return(
      this.state.isLoading ?
        <Loading />
      :
        <Grid>
          <Grid.Row>
            <Grid.Column>
              <List divided verticalAlign='middle' relaxed size="large">
                {
                    this.state.lessons.map(lesson => (
                        <List.Item key={lesson.number} as={Link} to={`/tajweed/${lesson.number}`}>
                            <Header size="small">
                                <Label color="red" circular content={lesson.number} />
                                {lesson.name}
                            </Header>  
                        </List.Item>
                    ))
                }    
              </List>
            </Grid.Column>
          </Grid.Row>   
        </Grid>
    );
  }
}
export default AllSurahView;